import styled from '@emotion/styled';
import { IChipStyle } from './chip.models';
import { theme } from '@vfit/shared/themes';

export const ChipStyle = styled.span<IChipStyle>`
  background-color: ${(p) => p.BgColor || theme.colors.text.secondary};
  border-radius: ${theme.radius.lg};
  color: ${(p) => p.color || theme.colors.bg.primary};
  display: inline-block;
  font-size: ${theme.typography.fontSize.caption};
  font-weight: ${theme.typography.fontWeight.bold};
  padding: ${theme.spacing.xs} ${theme.spacing.sm};
  ${(p) => (p.margin ? `margin: ${theme.spacing[p.margin[0]]} ${theme.spacing[p.margin[1]]};` : '')}
`;
